import ApiCore from './api-core'
import { PUBLIC } from './constants'

export default class Setting extends ApiCore {
  constructor(store) {
    super(store, `${PUBLIC}/setting`)
  }

  get(showProgress) {
    return this._request({
      method: 'GET',
      showProgress
    })
  }
}
